import React from 'react';
import { Trophy, Medal, Award } from 'lucide-react';

export function LeaderboardTable({
  rows,
  currentUserId,
  exactByUserId,
  language,
  onRowClick
}) {
  return (
    <div className="overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-card">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[320px] border-collapse text-left text-sm">
          <thead>
            <tr className="border-b border-zinc-200 bg-zinc-50/90 text-xs font-semibold uppercase tracking-wide text-zinc-500">
              <th className="px-4 py-3 sm:px-6">#</th>
              <th className="px-4 py-3 sm:px-6">{language === 'en' ? 'Player' : 'שחקן'}</th>
              <th className="px-4 py-3 text-right sm:px-6">
                {language === 'en' ? 'Points' : 'נקודות'}
              </th>
              <th className="hidden px-4 py-3 text-right sm:table-cell sm:px-6">
                {language === 'en' ? 'Exact' : 'מדויקים'}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => {
              const rank = index + 1;
              const id = row.userId || row._id;
              const isMe = currentUserId && String(id) === String(currentUserId);
              const exact =
                row.exactScores ??
                row.exactPredictions ??
                (exactByUserId && id ? exactByUserId[String(id)] : undefined);

              return (
                <tr
                  key={id || index}
                  onClick={() => onRowClick?.(id)}
                  className={[
                    'border-b border-zinc-100 transition-colors last:border-0',
                    isMe ? 'bg-brand-50/90' : 'hover:bg-zinc-50/80',
                    onRowClick ? 'cursor-pointer' : ''
                  ].join(' ')}
                >
                  <td className="px-4 py-4 sm:px-6">
                    <RankBadge rank={rank} />
                  </td>
                  <td className="px-4 py-4 font-semibold text-zinc-900 sm:px-6">
                    <span className="flex items-center gap-2">
                      {row.username || '—'}
                      {isMe && (
                        <span className="rounded-full bg-brand-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
                          {language === 'en' ? 'You' : 'אתה'}
                        </span>
                      )}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-right text-lg font-bold tabular-nums text-zinc-900 sm:px-6">
                    {row.totalPoints ?? 0}
                  </td>
                  <td className="hidden px-4 py-4 text-right text-zinc-600 tabular-nums sm:table-cell sm:px-6">
                    {exact !== undefined && exact !== null ? exact : '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {rows.length === 0 && (
        <p className="px-6 py-12 text-center text-zinc-500">
          {language === 'en' ? 'No players yet.' : 'אין שחקנים עדיין.'}
        </p>
      )}
    </div>
  );
}

function RankBadge({ rank }) {
  if (rank === 1)
    return (
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-brand-800">
        <Trophy className="h-5 w-5" />
      </span>
    );
  if (rank === 2)
    return (
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-zinc-200 text-zinc-700">
        <Medal className="h-5 w-5" />
      </span>
    );
  if (rank === 3)
    return (
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-orange-100 text-orange-800">
        <Award className="h-5 w-5" />
      </span>
    );
  return (
    <span className="inline-flex h-9 w-9 items-center justify-center font-bold text-zinc-500">
      {rank}
    </span>
  );
}
